import Alpine from 'alpinejs'

Alpine.data('addToWishlist', (productId: string) => ({

    isOn: false,

    init() {
        Alpine.effect(() => {
            this.isOn = Alpine.store('wishlist').isOnWishlist(productId);
        });
    },

    toggle() {
        if(!Alpine.store('session').authenticated) {
            this.$dispatch('login-requested');
            return;
        }
        Alpine.store('wishlist').toggle(productId);
    }
}));